import BackButton from "../components/BackButton";
import Logo from "../components/Logo";

export default function UnderDevelopment() {
  return (
    <div className="container p-5">
      <div
        className="d-flex align-items-center justify-content-center position-relative"
        style={{ height: "125px" }}
      >
        <BackButton />
        <Logo center className="mb-4" size="125px" />
      </div>

      <div className="text-center mt-5">
        <h2 className="fw-bold">Em desenvolvimento...</h2>
      </div>
    </div>
  );
}
